



























import { Component, Vue } from 'vue-property-decorator'
import WeatherCard from './components/WeatherCard.vue'
import { getData } from './api'
@Component({
    components: {
        WeatherCard,
    },
})
export default class App extends Vue {
    public country = ''
    public data = {}
    loading = true
    error = ''
    response = true

    submit(e: MouseEvent): void {
        e.preventDefault()
        this.loading = true
        this.response = false
        getData(this.country)
            .then((data) => {
                if (data.cod >= 400) {
                    this.error = data.message
                    this.response = false
                    this.loading = false
                } else {
                    this.response = true
                    this.loading = false
                    this.data = data.main
                    this.error = ''
                }
            })
            .catch((err) => {
                this.response = false
                this.loading = false
                this.error = err.message
            })
    }
}
